import * as React from 'react';
import type { ChipProps } from '@components/moleculs/chip/types';
import { Chip as BaseChip } from '@mui/material';

import { CloseIcon } from '../../icons';

import { ChipContainer } from './styles';

export const Chip: React.FC<ChipProps> = ({
    deleteIcon = <CloseIcon className='delete-icon' />,
    ...rest
}) => (
    <ChipContainer>
        <BaseChip deleteIcon={deleteIcon} {...rest} />
    </ChipContainer>
);
